import axiosInstance from './axiosInstance';

const aiAssistant = async (file, exception, reportData) => {
  try {
    const formData = new FormData();
    formData.append('image', file, 'screenshot.jpeg');
    formData.append('queryContent', exception);
    formData.append('testName', reportData?.name);
    formData.append('testReportId', reportData?.testReportId);
    formData.append('testMethodName', reportData?.testMethodName);
    const response = await axiosInstance.post('/aiAssistant/aiAssistant', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (err) {
    throw err.response;
  }
};
export default aiAssistant;
